import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { useCallback, useEffect, useState, } from 'preact/compat';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import useIsFirstRender from 'beautiful-react-hooks/useIsFirstRender';
import API from '@widgets/shared/API/connection';
import { overrideNotices } from '@basket/store/actions/notices';
import { useAppDispatch } from '@basket/store/hooks';
import defaultNumberFormat from '@widgets/shared/defaultNumberFormat';
import Minus from '@widgets/shared/components/icons/Minus';
import Plus from '@widgets/shared/components/icons/Plus';
const adjustProductQuantity = AwesomeDebouncePromise(API.adjustProductQty, 500);
const adjustMiscProductQuantity = AwesomeDebouncePromise(API.adjustMiscProductQty, 500);
function QuantityField(props) {
    const { fieldName, productPathId, band, type, canEdit, canDelete, allBands, } = props;
    const { Units: units, UnitPrice: unitPrice, PriceBandId: priceBandId, Minimum: min, Maximum: max, Multiple: multiple, } = band;
    const { control, getValues, setValue } = useFormContext();
    const { field: { value } } = useController({
        control,
        name: fieldName,
    });
    const dispatch = useAppDispatch();
    const firstRender = useIsFirstRender();
    const [inputValue, setInputValue] = useState(parseInt(`${value}`, 10));
    const updateBasket = useCallback((resp) => {
        const basketResponse = resp;
        window.dispatchEvent(new CustomEvent('basket.modify', {
            detail: basketResponse,
        }));
        dispatch(overrideNotices(resp.notices));
    }, [dispatch, setValue]);
    const handleInputValueChanged = useCallback(() => {
        if (!firstRender && value !== inputValue) {
            let request;
            if (type === 'misc') {
                const { MiscellaneousType: miscType, MiscellaneousId: miscId } = getValues(productPathId);
                request = adjustMiscProductQuantity(miscId, miscType, priceBandId, inputValue, allBands);
            }
            else {
                const { SessionId: sessionId } = getValues(productPathId);
                request = adjustProductQuantity(sessionId, priceBandId, inputValue, allBands);
            }
            request
                .then(updateBasket)
                .catch(updateBasket);
        }
    }, [firstRender, value, inputValue, type, updateBasket, getValues, productPathId, priceBandId, allBands]);
    const handleDecrease = () => {
        let newValue = parseInt(`${inputValue}`, 10) - multiple;
        newValue = Math.max(min, newValue);
        console.log('Setting the new value to ', newValue);
        setInputValue(newValue);
    };
    const handleIncrease = () => {
        const formattedInputValue = parseInt(`${inputValue}`, 10);
        // console.log(`min: ${min}, max: ${max}, multiple ${multiple}, input value ${formattedInputValue}`);
        let newValue = formattedInputValue + multiple;
        newValue = Math.min(max, newValue);
        console.log('Setting the new value to ', newValue);
        setInputValue(newValue);
    };
    useEffect(handleInputValueChanged, [inputValue, handleInputValueChanged]);
    // onChange={onChange}
    const inputWrapperClass = (type === 'misc' && !canEdit) ? 'quantity-input quantity-input--misc' : 'quantity-input';
    const renderQuantityInput = () => {
        if (type === 'misc' && !canEdit) {
            return (_jsx(_Fragment, { children: _jsx("span", { className: "quantity-input__price", children: `${defaultNumberFormat.format(unitPrice)}` }) }));
        }
        return (_jsxs(_Fragment, { children: [canEdit && (_jsx("button", { type: "button", className: "quantity-input__button decrease", onClick: handleDecrease, disabled: !canDelete && ((inputValue - multiple) < min), "aria-label": "Decrease quantity", children: _jsx(Minus, { fill: "#00AEEF" }) })), _jsx("input", { type: "number", className: "quantity-input__control blank-input", value: inputValue, disabled: !canEdit }), _jsx("span", { className: "quantity-input__price", children: `${defaultNumberFormat.format(unitPrice)}` }), canEdit && (_jsx("button", { type: "button", className: "quantity-input__button increase", onClick: handleIncrease, "aria-label": "Increase quantity", disabled: (inputValue + multiple) > max, children: _jsx(Plus, { fill: "#00AEEF" }) }))] }));
    };
    return (_jsx("div", { className: inputWrapperClass, children: renderQuantityInput() }));
}
QuantityField.defaultProps = {
    type: 'default',
};
export default QuantityField;
